import React from 'react'
import AboutUs from '../feature/AboutUs/AboutUs'

const AboutUsPage = () => {
  return <AboutUs/>
}

export default AboutUsPage